import {controller} from '@github/catalyst'

@controller('run-summary')
class RunSummaryElement extends HTMLElement {
  mouseEnterRerun(e: MouseEvent) {
    const jobId = (e.target as HTMLElement).getAttribute('data-job-id')
    if (jobId) {
      this.dispatchEvent(new CustomEvent('run-sidebar-job-enter', {detail: {jobId}, bubbles: true}))
    }
  }

  mouseLeaveRerun() {
    this.dispatchEvent(new CustomEvent('run-sidebar-job-leave', {bubbles: true}))
  }
}
